import axios from "axios"


// DEV_LOCAL : meme hote que la page (localhost sur le Mac, 192.168.1.x depuis
// le poste de Nawal), sinon le cookie de session ne suit pas. Cf thelab-front.
const hoteLocal = (port) => (typeof window !== "undefined"
  ? `https://${window.location.hostname}:${port}` : `https://localhost:${port}`)
export const glb_url = process.env.REACT_APP_APIS_BACK || hoteLocal(7443)

export const theLab_url = process.env.REACT_APP_THELAB_URL || hoteLocal(3000)


export default {
  /* DEBUT PASSPORTJS */
  // S2 : meme route que THE LAB (/user/updateAccount, protegee par la session,
  // utilisable par un compte THE SCAN). N'enregistre que name et poste.
  updateAccount : async vals => {
    try {
      const res = await axios.post(glb_url + "/user/updateAccount", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  // S8 : notifications + demande d'upgrade
  getNotifications : async () => {
    try {
      const res = await axios.post(glb_url + "/theScan/getNotifications", {}, { withCredentials: true })
      return res.data
    } catch (err) { return console.log(err) }
  },
  askForUpgrade : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/askForUpgrade", vals, { withCredentials: true })
      return res.data
    } catch (err) { return console.log(err) }
  },
  // Deconnexion serveur (la session restait ouverte auparavant)
  postLogout : async () => {
    try {
      const res = await axios.post(glb_url + "/auth/logout", {}, { withCredentials: true })
      return res.data
    } catch (err) { return null }
  },
  getLoginStatus: async () => {
    try {
      const res = await axios.get(glb_url + "/auth/status", {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      console.log(err)
      // 02/09/2026 : pas de reponse du serveur = on ne sait rien de la session.
      // Ne pas confondre avec une session fermee (voir front LAB, meme correctif).
      // 25/09/2026 : un 5xx (serveur ou base momentanement indisponible, 503
      // depuis B40) ne dit rien de la session non plus : ne pas deconnecter.
      return { reseauIndisponible : !err?.response || err.response.status >= 500 }
    }
  },

  postUserLogin: async user => {
    try {
      const res = await axios.post(glb_url + "/auth/login", user, {
        withCredentials: true,
      })
      return {
        err: false,
        data: res.data || "error logging in",
      }
    } catch (err) {
      return {
        err: true,
        data: false,
      }
    }
  },

  registerRecruiter : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/registerRecruiter", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkRegisterRecruiter : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/checkRegisterRecruiter", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  validCodeRecruiter : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/validCodeRecruiter", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  resendCodeRecruiter : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/resendCodeRecruiter", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkRegisterCandidat : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/checkRegisterCandidat", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  validRegisterCandidat : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/validRegisterCandidat", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  askForNewPasswordEmail : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/askForNewPasswordEmail", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkResetPsswd : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/checkResetPsswd", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  setPsswd: async (vals) => {
    try {
      const res = await axios.post(glb_url + "/theScan/setPsswd", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  changePassword : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/changePassword", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  /* FIN PASSPORTJS */

  /* DEBUT SCAN RECRUITER */
  addScanWithPDF: async (vals, onUploadProgress) => {
    try {
      const res = await axios.put(glb_url + "/theScan/addScan", vals, {
        onUploadProgress : onUploadProgress,
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addScanWithDescription : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/addScan", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getScans : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/getScans", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addCandidat : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/addCandidat", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addMultipleCandidats : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/addMultipleCandidats", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  reInvitCandidat : async vals => {
    try {
      const res = await axios.post(glb_url + "/theScan/reInvitCandidat", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  /* FIN SCAN RECRUITER */

  /* SUPPORT — chat maison, remplace Crisp. Appelable sans session.
   * La variable d'URL s'appelle `glb_url` ici (`GLB_URL_APIS` cote THE LAB) :
   * recopier le bloc sans renommer laissait un identifiant inexistant, avale
   * par le `catch`, donc un widget muet.
   * Il n'y a volontairement PAS de bloc admin ici : la boite de reception du
   * support vit dans l'admin THE LAB, qui filtre par plateforme. */
  supportMessage : async vals => {
    try {
      const res = await axios.post(glb_url + "/support/message", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return err.response?.data || { error: true, data: "reseau" }
    }
  },

  supportFil : async vals => {
    try {
      const res = await axios.post(glb_url + "/support/fil", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      // Un echec de sondage est benin : on renvoie null, le widget reessaiera.
      return null
    }
  },
}
